<template>
  <div class="d-flex flex-column">
    <div class="iext__filler flex-grow-1">
      <div ref="refiext" class="iext__image_container" draggable="false">
        <img
          :src="src"
          class="iext__image"
          draggable="false"
          alt=""
          @load="onImageLoad"
        />
        <div class="iext__cross-container" draggable="false">
          <div class="iext__hole" :style="getHoleStyle" />
          <div
            class="iext__cross-paddingbox"
            draggable="false"
            @mouseleave="onMouseUp"
            @mouseup="onMouseUp"
            @mousemove="onMouseMove"
          >
            <div
              class="iext__hole-draggable"
              :style="getHoleStyle"
              @mousedown="onHoleMouseDown"
            />
            <div
              class="iext__cross"
              :style="getBtStyle('left', 'top')"
              @mousedown="onMouseDown('left', 'top')"
              @mouseup="onMouseUp"
            />
            <div
              class="iext__cross inv"
              :style="getBtStyle('right', 'top')"
              @mousedown="onMouseDown('right', 'top')"
              @mouseup="onMouseUp"
            />
            <div
              class="iext__cross"
              :style="getBtStyle('right', 'bottom')"
              @mousedown="onMouseDown('right', 'bottom')"
              @mouseup="onMouseUp"
            />
            <div
              class="iext__cross inv"
              :style="getBtStyle('left', 'bottom')"
              @mousedown="onMouseDown('left', 'bottom')"
              @mouseup="onMouseUp"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import uniqueId from "lodash/uniqueId";

export default {
  props: {
    value: {
      type: Object,
      required: true
    },
    src: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      defSize: 30,
      drag: {
        left: false,
        top: false,
        right: false,
        bottom: false
      },
      dragAny: false,
      dragRect: false,
      dragRectDx: null,
      dragRectDy: null
    };
  },
  computed: {
    imageAssets: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    },
    getBtStyle() {
      return (bLeft, bTop) => ({
        left: `${this.imageAssets[bLeft]}%`,
        top: `${this.imageAssets[bTop]}%`
      });
    },
    getHoleStyle() {
      return {
        left: `${this.imageAssets.left}%`,
        top: `${this.imageAssets.top}%`,
        width: `${this.imageAssets.right - this.imageAssets.left}%`,
        height: `${this.imageAssets.bottom - this.imageAssets.top}%`
      };
    },
    uniqid() {
      return uniqueId();
    }
  },
  methods: {
    onImageLoad() {
      const imageRect = this.$refs.refiext.getBoundingClientRect();
      if (imageRect.width == 0 || imageRect.height == 0) return;

      if (this.imageAssets.left == null) {
        if (imageRect.width < imageRect.height) {
          this.imageAssets.left = 50 - this.defSize;
          this.imageAssets.right = 50 + this.defSize;
          this.imageAssets.top =
            50 - (imageRect.width / imageRect.height) * this.defSize;
          this.imageAssets.bottom =
            50 + (imageRect.width / imageRect.height) * this.defSize;
        } else {
          this.imageAssets.top = 50 - this.defSize;
          this.imageAssets.bottom = 50 + this.defSize;
          this.imageAssets.left =
            50 - (imageRect.height / imageRect.width) * this.defSize;
          this.imageAssets.right =
            50 + (imageRect.height / imageRect.width) * this.defSize;
        }
        this.$emit("input", this.imageAssets);
      }
    },

    onMouseDown(bLeft, bTop) {
      this.dragAny = true;
      this.drag[bLeft] = true;
      this.drag[bTop] = true;
    },
    onMouseMove(e) {
      if (this.dragAny) this.onMouseMoveHandle(e);
      else if (this.dragRect) this.onMouseMoveRect(e);
    },
    onMouseMoveHandle(e) {
      const imageRect = this.$refs.refiext.getBoundingClientRect();
      const coords = { ...this.imageAssets };
      const aspectRatio = imageRect.width / imageRect.height;
      const x =
        Math.round(((e.clientX - imageRect.left) / imageRect.width) * 100000) /
        1000;
      const y =
        Math.round(((e.clientY - imageRect.top) / imageRect.height) * 100000) /
        1000;

      for (const entry in this.drag) {
        if (this.drag[entry]) {
          coords[entry] = ["left", "right"].includes(entry) ? x : y;
        }
      }

      const d = Math.max(
        coords.right - coords.left,
        (coords.bottom - coords.top) / aspectRatio
      );

      if (this.drag.left) {
        coords.left = Math.round((coords.right - d) * 1000) / 1000;
      }
      if (this.drag.right) {
        coords.right = Math.round((coords.left + d) * 1000) / 1000;
      }
      if (this.drag.top) {
        coords.top =
          Math.round((coords.bottom - d * aspectRatio) * 1000) / 1000;
      }
      if (this.drag.bottom) {
        coords.bottom =
          Math.round((coords.top + d * aspectRatio) * 1000) / 1000;
      }
      if (
        coords.right - coords.left < 5 ||
        coords.left < 1 ||
        coords.right > 100 - 1 ||
        coords.bottom - coords.top < 5 * aspectRatio ||
        coords.top < 1 * aspectRatio ||
        coords.bottom > 100 - 1 * aspectRatio
      ) {
        return true;
      }
      this.$emit("input", coords);
    },

    onMouseMoveRect(e) {
      const imageRect = this.$refs.refiext.getBoundingClientRect();
      const coords = { ...this.imageAssets };
      const aspectRatio = imageRect.width / imageRect.height;
      const x =
        Math.round(((e.clientX - imageRect.left) / imageRect.width) * 100000) /
        1000;
      const y =
        Math.round(((e.clientY - imageRect.top) / imageRect.height) * 100000) /
        1000;

      const dw = coords.right - coords.left;
      const dh = coords.bottom - coords.top;

      coords.left = x - this.dragRectDx;
      coords.top = y - this.dragRectDy;
      coords.right = coords.left + dw;
      coords.bottom = coords.top + dh;

      if (coords.left < 1 || coords.right > 100 - 1) return true;
      if (coords.top < 1 * aspectRatio || coords.bottom > 100 - 1 * aspectRatio)
        return true;

      this.$emit("input", coords);
    },

    onMouseUp() {
      this.dragAny = false;
      this.drag.left = false;
      this.drag.top = false;
      this.drag.right = false;
      this.drag.bottom = false;
      this.dragRect = false;
      this.dragRectX = null;
      this.dragRectY = null;
    },
    onHoleMouseDown(e) {
      this.dragRect = true;
      const imageRect = this.$refs.refiext.getBoundingClientRect();
      this.dragRectDx =
        Math.round(((e.clientX - imageRect.left) / imageRect.width) * 100000) /
          1000 -
        this.imageAssets.left;
      this.dragRectDy =
        Math.round(((e.clientY - imageRect.top) / imageRect.height) * 100000) /
          1000 -
        this.imageAssets.top;
    }
  }
};
</script>

<style lang="scss" scoped>
.iext__filler {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  .iext__image_container {
    position: relative;

    .iext__image {
      display: block;
      user-select: none;
      width: 100%;
      height: auto;
      pointer-events: none;
    }

    .iext__shader {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      overflow: hidden;
      svg {
        display: block;
        width: 100%;
        height: 100%;
      }
    }

    .iext__cross-container {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      overflow: hidden;

      .iext__hole {
        position: absolute;
        margin-left: -2000px;
        margin-top: -2000px;
        box-sizing: content-box;
        background: transparent;
        border-radius: 50%;
        border: 2000px solid rgba(0, 0, 0, 0.5);
      }

      .iext__cross-paddingbox {
        position: relative;
        width: 100%;
        height: 100%;

        .iext__hole-draggable {
          position: absolute;
          border-radius: 50%;
          cursor: move;
        }

        .iext__cross {
          position: absolute;
          width: 14px;
          height: 14px;
          margin-left: -7px;
          margin-top: -7px;
          background-color: rgba(255, 255, 255, 0.6);
          user-select: none;
          cursor: nwse-resize;
          &.inv {
            cursor: nesw-resize;
          }
        }
      }
    }
  }
}

.iext__controls {
  padding: 8px;

  .iext__fill-control {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    border: 1px solid #777777;
    color: white;
    cursor: pointer;
  }
}
</style>
